import React, { createContext, useState, useContext } from 'react';

const ClientContext = createContext(null);

export const useClient = () => useContext(ClientContext);

export const ClientProvider = ({ children }) => {
    const [goals, setGoals] = useState([]);

    const addGoal = (goal) => {
        setGoals([...goals, goal]);
    };

    const loadGoals = (existingGoals) => {
        setGoals(existingGoals);
    };

    return (
        <ClientContext.Provider value={{ goals, addGoal, loadGoals }}>
            {children}
        </ClientContext.Provider>
    );
};
